// Search input + Filters button for members table (Figma layout)
import React from 'react';
import { Search, Filter } from 'lucide-react';

const MemberSearchBar = ({
  searchValue,
  onSearchChange,
  onFiltersClick = () => {},
  filterOpen = false,
  activeFilterCount = 0,
  hideFilters = false,
  children,
}) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-pt-4 tw-pb-2">
      {/* Search input */}
      <div className={`tw-relative ${hideFilters ? 'tw-w-full' : 'tw-w-full md:tw-w-96'}`}>
        <Search className="tw-absolute tw-left-3 tw-top-1/2 tw--translate-y-1/2 tw-w-4 tw-h-4 tw-text-gray-400" />
        <input
          type="text"
          placeholder="Search by name, email, or vessel..."
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          className="tw-w-full tw-pl-10 tw-pr-4 tw-py-2.5 tw-border tw-border-gray-200 tw-rounded-xl tw-text-sm focus:tw-ring-2 focus:tw-ring-indigo-500/20 focus:tw-border-indigo-400 tw-outline-none tw-transition-all tw-bg-white tw-shadow-sm"
        />
      </div>

      {/* Filters button + popover container */}
      {!hideFilters && (
        <div className="tw-relative">
          <button
            data-filter-toggle
            onClick={onFiltersClick}
            className={`tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-border tw-rounded-lg tw-text-sm tw-font-medium tw-cursor-pointer tw-transition-colors tw-whitespace-nowrap ${
              activeFilterCount > 0
                ? 'tw-border-indigo-200 tw-text-indigo-700 tw-bg-indigo-50 hover:tw-bg-indigo-100'
                : 'tw-border-gray-300 tw-text-gray-700 tw-bg-white hover:tw-bg-gray-50'
            }`}
          >
            <Filter className="tw-w-4 tw-h-4" />
            Filters
            {activeFilterCount > 0 && (
              <span className="tw-ml-1 tw-bg-indigo-600 tw-text-white tw-text-[10px] tw-px-1.5 tw-py-0.5 tw-rounded-full">
                {activeFilterCount}
              </span>
            )}
          </button>
          {/* Popover rendered as child, positioned absolute relative to this container */}
          {children}
        </div>
      )}
    </div>
  );
};

export default MemberSearchBar;
